import * as React from 'react';
import TextField from '@mui/material/TextField';
import { useField } from 'formik';
import HandleError from '../HandleError';

export default function NumberFieldComponent({ name, ...props }) {
  const [field] = useField({ name, ...props });
  return (
    <>
      <TextField
        size="small"
        type="number"
        {...field}
        {...props}
      />
      <HandleError name={name} />
    </>
  );
}
